import { render, staticRenderFns } from "./TheSystemSettings.vue?vue&type=template&id=1915030a&scoped=true&"
import script from "./TheSystemSettings.vue?vue&type=script&lang=js&"
export * from "./TheSystemSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1915030a",
  null
  
)

export default component.exports